import React, { useReducer, useEffect } from "react";

import fire from "../../firebase.config";
import { toast } from "react-toastify";
import authReducer from "./reducer";
import AuthContext from "./Context";
import { LOGOUT_USER, LOGIN_USER } from "../types";

const AuthState = props => {
  const initialState = {
    isLoggedIn: false,
    userInfo: null
  };

  const loginUser = (email, password) => {
    fire
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(res => {
        if (res.credential) {
          var token = res.credential.accessToken;
          console.log(
            "%c Token from google : " + token,
            "background-color: red; color: blue;"
          );
        }
        dispatch({ type: LOGIN_USER, payload: res.user });
        toast.success("Login Successful !");
      })
      .catch(function(error) {
        toast.error(error.message);
      });
  };

  const logoutUser = () => {
    fire
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: LOGOUT_USER });
        toast.success("Logout Successful !");
      })
      .catch(error => {
        toast.error(error.message);
      });
  };

  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          user.superAdmin = idTokenResult.claims.superAdmin;
          user.admin = idTokenResult.claims.admin;
          if (user.admin || user.superAdmin) {
            dispatch({ type: LOGOUT_USER });
            toast.error("Please login at admin.dismissed4less.com");
          } else {
            dispatch({ type: LOGIN_USER, payload: user });
            toast.success("Logged in as " + user.email);
          }
        });
      } else {
        //dispatch({ type: LOGOUT_USER });
      }
    });
    // eslint-disable-next-line
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: state.isLoggedIn,
        userInfo: state.userInfo,
        logoutUser,
        loginUser
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
